import type { ReactNode } from 'react';
import { Card, CardBody, CardHeader } from '../kit/card';

/**
 * A message card: the unauthorized, unavailable, not-found and legacy pages. A legacy `.card`
 * with the title in its header.
 */
export function StatusPage({
  title,
  message,
  children,
}: {
  title: string;
  message: string;
  children?: ReactNode;
}) {
  return (
    <Card className="mx-auto mt-8 max-w-xl">
      <CardHeader>
        <h1 className="mb-0 text-sm leading-normal font-bold">{title}</h1>
      </CardHeader>
      <CardBody>
        {message ? <p className="mb-4 text-ink-muted">{message}</p> : null}
        {children ? <div className="flex flex-wrap gap-2">{children}</div> : null}
      </CardBody>
    </Card>
  );
}
